export function on<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args: Parameters<T['addEventListener']>
): (() => void) | undefined {
  if (!obj || !obj.addEventListener) return;
  obj.addEventListener(...(args as Parameters<HTMLElement['addEventListener']>));
  return function off() {
    if (!obj || !obj.removeEventListener) return;
    obj.removeEventListener(...(args as Parameters<HTMLElement['removeEventListener']>));
  };
}
